export default __webpack_public_path__ + "static/media/Nunito-Regular.7c16b0ae.svg";